/**
 * Archiving a campaign — the one place that knows what "archived" means.
 *
 * A campaign is archived, never deleted (see 0021_campaign_archive.sql for why:
 * deleting one cascaded away the send_queue rows the entire dashboard counts).
 * `archived_at` non-null means: hidden from the Campaigns list and every picker,
 * refused as an import target, never sent by the cron — but every row it owns is
 * kept, so its history keeps counting everywhere history is counted.
 *
 * MIGRATION TOLERANCE. 0021 is applied by hand in the Supabase SQL editor, so
 * every reader here has to work on a database that does not have the column yet.
 * PostgREST answers a filter on a missing column with 42703 and fails the WHOLE
 * request, which would take the Campaigns screen and the sender down with it.
 * The rule is: degrade to unfiltered. That is not a guess — without the column
 * NO campaign can be archived, so "all of them" is the correct answer.
 */

/** True when the failure is "this database has not run 0021 yet". */
export function isMissingArchiveColumn(error: {
  code?: string
  message?: string
} | null): boolean {
  if (!error) return false
  return error.code === '42703' && /archived_at/.test(error.message ?? '')
}

/** Non-null archived_at, tolerating a database that predates 0021. */
export function isArchived(c: { archived_at?: string | null } | null | undefined): boolean {
  return !!c?.archived_at
}
